export default "__VITE_ASSET__xtaVaOvE__"